export default function isAbsoluteURL(url) {
  return /^https?:\/\//.test(url)
}
